import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import TicketForm from './components/TicketForm';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState('dashboard');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    
    return () => unsubscribe();
  }, []);

  // URL-Parameter auslesen für Seitennavigation
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('/form') || path.includes('/ticket')) {
      setCurrentPage('form');
    } else if (path.includes('/login')) {
      setCurrentPage('login');
    } else {
      setCurrentPage('dashboard');
    }
  }, []);

  // URL aktualisieren ohne tatsächlichen Reload
  const navigateTo = (page) => {
    setCurrentPage(page);
    window.history.pushState({}, '', page === 'dashboard' ? '/' : `/${page}`);
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Wird geladen...</div>;
  }

  // Zeige Login, wenn User nicht eingeloggt ist (außer beim Formular)
  if (!user && currentPage !== 'form') {
    return <Login onLoginSuccess={() => navigateTo('dashboard')} />;
  }

  // Rendere die passende Komponente basierend auf der aktuellen Seite
  if (currentPage === 'form') {
    return <TicketForm />;
  }

  // Rendere Dashboard, wenn der Benutzer eingeloggt ist
  return <Dashboard />
}

export default App;